import { createAction, props } from "@ngrx/store";
import { CatalogoPaises, CatalogoCodigosPostales, CatalogoColonia, CatalogoMunicipio, CatalogoEstados } from "../../interfaces/interfaces.interface";

export const searchPaises = createAction(
    '[Catalogo] Buscando países',
    props<{ dispatcher: string }>()
);
export const foundPaises = createAction(
    '[Catalogo] Países encontrados',
    props<{ data: CatalogoPaises[] }>()
);
export const searchEstados = createAction(
    '[Catalogo] Buscando estados',
    props<{ pais: string, dispatcher: string }>()
);
export const foundEstados = createAction(
    '[Catalogo] Estados encontrados',
    props<{ data: CatalogoEstados[] }>()
);
export const searchMunicipios = createAction(
    '[Catalogo] Buscando municipios',
    props<{ estado: string, dispatcher: string }>()
);
export const foundMunicipios = createAction(
    '[Catalogo] Municipios encontrados',
    props<{ data: CatalogoMunicipio[] }>()
);
export const searchCodigosPostales = createAction(
    '[Catalogo] Buscando códigos postales',
    props<{ municipio: string, dispatcher: string }>()
);
export const foundCodigosPostales = createAction(
    '[Catalogo] Códigos postales encontrados',
    props<{ data: CatalogoCodigosPostales[] }>()
);
export const searchColonias = createAction(
    '[Catalogo] Buscando colonias',
    props<{ codigoPostal: string, dispatcher: string }>()
);
export const foundColonias = createAction(
    '[Catalogo] Colonias encontrados',
    props<{ data: CatalogoColonia[] }>()
);



export const errorGetCatalogo = createAction(
    '[Catalogo] Error al obtener el catalogo',
);